module.exports = __webpack_public_path__ + "img/chinesecompany07.cbb8138d.png";